import { render } from "./EmployeeLeave.vue?vue&type=template&id=38047877&scoped=true"
import script from "./EmployeeLeave.vue?vue&type=script&lang=js"
export * from "./EmployeeLeave.vue?vue&type=script&lang=js"

import "./EmployeeLeave.vue?vue&type=style&index=0&id=38047877&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38047877"]])

export default __exports__